import React from 'react';

import { Box, H4, Icon, IconName, IconTile, ListRow, Text } from '@betterment/samba-react';
import { useNavigate } from 'react-router-dom';

import { AccountOwnershipOptionsQuery } from '../graphql/AccountOwnershipOptions.generated';

type AccountOwnershipOption = AccountOwnershipOptionsQuery['goalCreationOption']['accountOwnershipOptions'][number];

type AccountOwnershipRowProps = {
  option: AccountOwnershipOption;
  icon: IconName;
  path: string;
  onClick: () => void;
};

export const AccountOwnershipRow: React.FC<AccountOwnershipRowProps> = ({ option, icon, path, onClick }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    onClick();
    void navigate(path);
  };

  return (
    <Box className="group" onClick={handleClick} css={{ cursor: 'pointer' }}>
      <ListRow css={{ px: '0' }}>
        <ListRow.LeadingAsset css={{ width: '36px' }}>
          <IconTile name={icon} css={{ color: 'icon' }} />
        </ListRow.LeadingAsset>
        <ListRow.LeadingContent>
          <H4
            variant="title100"
            color="text"
            css={{ textDecoration: { _groupHover: 'underline', _groupFocus: 'underline' } }}
          >
            {option.name}
          </H4>
          <Text variant="text50" color="text.weak">
            {option.description}
          </Text>
        </ListRow.LeadingContent>
        <ListRow.TrailingAsset>
          <Icon name="CaretRight" size="small" color="icon" />
        </ListRow.TrailingAsset>
      </ListRow>
    </Box>
  );
};
